import { toast } from 'react-toastify';
import { Trash2 } from 'lucide-react';
import { ColumnDef } from '@tanstack/react-table';
import { useQueryClient } from '@tanstack/react-query';
import { DepartmentQueryData } from '@area-restrita/api-client/model/departmentQueryData';
import { useDeleteCompanyDepartment } from '@area-restrita/api-client/endpoints/departments/departments.gen';

import Dialog from '@/components/template/Dialog';
import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

export const columns: ColumnDef<DepartmentQueryData>[] = [
  { accessorKey: 'name', header: 'Nome' },
  {
    accessorKey: 'description',
    header: 'Descrição',
    meta: { className: 'text-right' },
  },
  {
    header: 'Ações',
    meta: { className: 'text-right', onClick: (e) => e.stopPropagation() },
    cell: function CompanyDepartmentActionsCell({ row }) {
      const { checkAuthorization } = useAuthSessionStore();

      const canDelete = checkAuthorization(({ can }) =>
        can('delete', 'departments'),
      );
      const queryClient = useQueryClient();

      const { mutateAsync: deleteCompanyDepartment } =
        useDeleteCompanyDepartment({
          mutation: {
            onSuccess: async () => {
              await queryClient.invalidateQueries({
                queryKey: ['/api/v1/departments'],
              });

              toast.success('Departamento excluído com sucesso!');
            },
            onError: () => toast.error('Erro ao excluir departamento!'),
          },
        });

      return (
        <div className="flex justify-end gap-3">
          <Dialog
            title="Excluir Departamento"
            trigger={
              <Button
                variant="destructive"
                size="icon-sm"
                disabled={!canDelete}
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            }
          >
            <p>Tem certeza que deseja excluir este departamento?</p>
            <DialogFooter>
              <Button
                variant="destructive"
                size="sm"
                onClick={() => deleteCompanyDepartment({ id: row.original.id })}
              >
                Excluir
              </Button>
            </DialogFooter>
          </Dialog>
        </div>
      );
    },
  },
];
